import jsPDF from "jspdf";
import { WashBooking } from "../types/admin/washBookings.types";

export const downloadWashBookingPDF = (booking: WashBooking) => {
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();

  let y = 20;

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(20);
  pdf.text("Autocare", pageWidth / 2, y, { align: "center" });

  y += 10;

  pdf.setFontSize(12);
  pdf.setFont("helvetica", "bold");
  pdf.text("Booking Details", pageWidth / 2, y, { align: "center" });

  y += 10;
  pdf.line(15, y, pageWidth - 15, y);
  y += 10;

  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");

  pdf.text(`Booking ID: ${booking._id}`, 15, y);
  pdf.text(`Date: ${booking.date.split("T")[0]}`, pageWidth - 15, y, {
    align: "right",
  });

  y += 6;
  pdf.text(`Status: ${booking.status}`, 15, y);
  pdf.text(`Slot: ${booking.slotTime}`, pageWidth - 15, y, {
    align: "right",
  });

  y += 12;

  pdf.setFont("helvetica", "bold");
  pdf.text("Car Details", 15, y);
  y += 6;

  pdf.setFont("helvetica", "normal");

  const carText = booking.car
    ? `${booking.car.brand} ${booking.car.model} (${booking.car.number})`
    : booking.carId;

  pdf.text(`Car: ${carText}`, 15, y);
  y += 6;

  if (booking.city) {
    pdf.text(`City: ${booking.city}`, 15, y);
    y += 8;
  }

  pdf.setFont("helvetica", "bold");
  pdf.text("Customer", 15, y);
  y += 6;

  pdf.setFont("helvetica", "normal");
  pdf.text(booking.user?.name || booking.userId, 15, y);
  y += 6;

  if (booking.user?.phone) {
    pdf.text(`Phone: ${booking.user.phone}`, 15, y);
    y += 6;
  }

  if (booking.user?.email) {
    pdf.text(`Email: ${booking.user.email}`, 15, y);
    y += 6;
  }

  y += 10;

  pdf.setFont("helvetica", "bold");
  pdf.text("Item", 15, y);
  pdf.text("Price", pageWidth - 15, y, { align: "right" });

  y += 2;
  pdf.line(15, y, pageWidth - 15, y);
  y += 6;

  pdf.setFont("helvetica", "normal");

  const itemName = booking.package?.title || "Car Wash Package";

  pdf.text(itemName, 15, y);
  pdf.text(`Rs. ${booking.price}`, pageWidth - 15, y, {
    align: "right",
  });

  y += 10;
  pdf.line(15, y, pageWidth - 15, y);
  y += 8;

  pdf.setFont("helvetica", "bold");
  pdf.text("Total", 15, y);
  pdf.setFontSize(14);
  pdf.text(`Rs. ${booking.price}`, pageWidth - 15, y, {
    align: "right",
  });

  pdf.setFontSize(9);
  pdf.setFont("helvetica", "normal");
  pdf.text("Thanks for choosing Autocare", pageWidth / 2, 285, {
    align: "center",
  });

  pdf.save(`wash-booking-${booking._id}.pdf`);
};
